import { useState, useEffect } from "react";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("toolmatch-cookie-consent");
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("toolmatch-cookie-consent", "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("toolmatch-cookie-consent", "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-fade-in-up">
      <div className="container-wide">
        <div className="glass-card flex flex-col gap-4 p-6 md:flex-row md:items-center md:justify-between">
          <div className="flex items-start gap-4">
            <div className="rounded-lg bg-primary/10 p-2">
              <Cookie className="h-5 w-5 text-primary" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-foreground">
                We use cookies
              </h3>
              <p className="mt-1 text-sm text-muted-foreground">
                We use cookies to improve your experience and for analytics.{" "}
                <Link to="/cookies" className="text-primary hover:underline">
                  Learn more about our cookie policy
                </Link>
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={handleDecline}
              className="rounded-lg border border-border/50 bg-secondary/50 px-4 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="btn-accent px-4 py-2 text-sm"
            >
              <span>Accept</span>
            </button>
            <button
              onClick={handleDecline}
              aria-label="Dismiss cookie consent"
              className="rounded-lg p-2 text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground md:hidden"
            >
              <X size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
